<div class="row g-2 mb-0">
  <div class="col-6 col-md-3">
    <div class="card border">
      <div class="card-body p-2">
        <div class="small text-muted text-uppercase mb-1">{{ 'Settings::DataImport:TimeRemaining' | abpLocalization }}</div>
        <div class="fw-bold">
          <ng-container *ngIf="timeRemaining != null; else noTimeRemaining">
            {{ timeRemaining | cxTimePipe : true }}
          </ng-container>
          <ng-template #noTimeRemaining>
            <span *ngIf="isCalculatingTimeRemaining; else dashTime" class="text-muted fst-italic">
              {{ 'Settings::DataImport:TimeRemainingCalculating' | abpLocalization }}
            </span>
            <ng-template #dashTime>--</ng-template>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class="col-6 col-md-3">
    <div class="card border" [class.cursor-pointer]="hasErrors" (click)="onErrorClick()">
      <div class="card-body p-2">
        <div class="small text-muted text-uppercase mb-1">{{ 'Settings::DataImport:ErrorsEncountered' | abpLocalization }}</div>
        <div class="fw-bold" [class.text-danger]="hasErrors">
          {{ errorCount > 0 ? errorCount : '--' }}
        </div>
      </div>
    </div>
  </div>

  <div class="col-6 col-md-3">
    <div class="card border">
      <div class="card-body p-2">
        <div class="small text-muted text-uppercase mb-1">{{ 'Settings::DataImport:SystemStartDate' | abpLocalization }}</div>
        <div class="fw-bold">
          {{ systemStartDate ? (systemStartDate | displayDateTime) : '--' }}
        </div>
      </div>
    </div>
  </div>

  <div class="col-6 col-md-3">
    <div class="card border">
      <div class="card-body p-2">
        <div class="small text-muted text-uppercase mb-1">{{ 'Settings::DataImport:LastImport' | abpLocalization }}</div>
        <div class="fw-bold">
          {{ lastImport ? (lastImport | displayDateTime) : '--' }}
        </div>
      </div>
    </div>
  </div>
</div>
